var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 550",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.6,134.4c-4.4,0-8.58,0.93-12.43,2.45l190.05,166.07c8.21,7.18,16.96,7.18,25.2,0l190.4-166.07 c-3.84-1.53-8.02-2.45-12.43-2.45L159.6,134.4L159.6,134.4z M126.35,163.27c-0.21,1.53-0.35,3.13-0.35,4.72v224 c0,18.61,14.98,33.6,33.6,33.6h380.8c18.61,0,33.6-14.98,33.6-33.6V168c0-1.59-0.14-3.2-0.35-4.73L384.47,328.3 c-19.74,17.21-49.56,17.24-69.3,0L126.35,163.27L126.35,163.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bc37548c4c33df0d72cea5db1221f17b.svg";
export { ForwardRef as ReactComponent };